import { GET_LEADERBOARDS, GET_LEADERBOARDS_SUCCESS, GET_LEADERBOARDS_FAILURE } from "./actionTypes"
const initialState = { error: false, leaderboards: null, loading: false }
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LEADERBOARDS: return { ...state, loading: true, error: false }
    case GET_LEADERBOARDS_SUCCESS: return { ...state, loading: false, error: false, leaderboards: action.payload }
    case GET_LEADERBOARDS_FAILURE: return { ...state, loading: false, error: true }
    default: return state
  }
}
